<script>
  import Select from "svelte-select";
  import Item from "./CountryItem.svelte";
  import Selection from "./CountrySelection.svelte";
  import Input from "../Input/Input.svelte";
  import { countries } from "./countries";
  import { i18n } from "../../../i18n";

  export let phone = "";
  export let countryPhonePrefix = undefined;

  const items = countries.map((item) => {
    return {
      value: item.code,
      label: item.value,
      shortName: item.value,
      fullName: $i18n.t(item.fullName),
      image_url: `images/countries/${item.value.toLowerCase()}.png`,
    };
  });

  const otherCountry = items[items.length - 1];

  // Dial prefixes are shared (+7 is both RU and KZ), so the first match wins:
  // this is a default the patient can change, not a determination of where
  // they are. A prefix no row carries is shown against the "another country"
  // row rather than discarded, so a caller from a country we ship no flag for
  // still gets their own code instead of somebody else's.
  function resolve(prefix) {
    return (
      items.find((item) => item.value === prefix) || {
        ...otherCountry,
        value: prefix,
      }
    );
  }

  let internalValue = resolve(countryPhonePrefix);

  // Following the prefix only when it names another country keeps a
  // hand-picked KZ from being snapped back to RU.
  $: if (countryPhonePrefix !== internalValue.value) {
    internalValue = resolve(countryPhonePrefix);
  }

  const handleSelect = (event) => {
    internalValue = event.detail;
    // Actual value
    countryPhonePrefix = event.detail.value;
  };
</script>

<div class="countryCodeWrapper">
  <div class="select_wrapper">
    <!--
      `listAutoWidth` matches the list to the select, and the select is
      only as wide as a dial code: the country names would be cut off.
    -->
    <Select
      itemId="shortName"
      label="label"
      value={internalValue}
      clearable={false}
      searchable={false}
      listAutoWidth={false}
      filterSelectedItems={false}
      on:change={handleSelect}
      {items}
    >
      <Item slot="item" let:item {item} />
      <Selection slot="selection" let:selection item={selection} />
    </Select>
  </div>
  <Input isPhoneInput={true} type="tel" mask bind:value={phone} />
</div>

<style>
  .countryCodeWrapper {
    flex: 1;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
  }
  .select_wrapper {
    /* Override some select variables */
    --height: 46px;
    --selected-item-padding: 0;
    --border-radius: 8px;
    --input-padding: 0;
    --padding: 0;
    --value-container-padding: 0;
    --border: none;
    --border-hover: none;
    --border-focused: none;
    /* The rows carry their own box in CountryItem, so the only thing left for
       the select itself is the state colouring it applies to the wrapper. */
    --item-padding: 0;
    --item-height: 40px;
    --item-line-height: 40px;
    --item-first-border-radius: 4px 4px 0 0;
    --item-is-active-bg: var(--primaryOpacity);
    --item-is-active-color: var(--black);
    --item-hover-bg: #e7f2ff;
    --item-hover-color: var(--black);
    /* QUALITY STYLING*/
    height: 48px;
    display: flex;
    align-items: center;
    background: var(--silver);
    padding-left: 1px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  :global(.Input.Phone) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  :global(.svelte-select) {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :global(.selected-item) {
    display: flex;
    align-items: center;
  }
</style>
